import { render } from "./Pen.vue?vue&type=template&id=41a1bf06&scoped=true"
const script = {}

import "./Pen.vue?vue&type=style&index=0&id=41a1bf06&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a1bf06"]])

export default __exports__